import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AgencyNewsList.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';

const AgencyNewsList = () => {

    // const navigate = useNavigate();
    // const app_url = configData.APP_URL;
   const [isLoading, setIsLoading] = useState(true);
   const [blogData, setBlogData] = useState([]);
   const [visibleCount, setVisibleCount] = useState(10);
 const app_url = configData.APP_URL;
 
    useEffect(() => {
        const blogData = [
  {
    date: "November 02, 2025",
    title: "SMWW Agent Advisor Kenya Fari Earns FIBA Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/SMWW_Agency-Kenya_Fari_Agent_Advisor.png",
    link: "/content/smww-agent-advisor-kenya-fari-earns-fiba-certification",
  },
  {
    date: "October 20, 2025",
    title: "SMWW Hockey Agency Director Michael Collier Earns Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Michael_Collier_SMWW_Hockey_Agency_Director.png",
    link: "/content/smww-hockey-agency-director-michael-collier-earns-pwhlpa-player-agent-certification",
  },
  {
    date: "September 15, 2025",
    title: "Another Article Title",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Luquay_Washington.png",
    link: "/content/smww-agency-welcomes-new-athlete-luquay-washington",
  },
  //first
  
    {
    date: "November 02, 2025",
    title: "SMWW Agent Advisor Kenya Fari Earns FIBA Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/SMWW_Agency-Kenya_Fari_Agent_Advisor.png",
    link: "/content/smww-agent-advisor-kenya-fari-earns-fiba-certification",
  },
  {
    date: "October 20, 2025",
    title: "SMWW Hockey Agency Director Michael Collier Earns Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Michael_Collier_SMWW_Hockey_Agency_Director.png",
    link: "/content/smww-hockey-agency-director-michael-collier-earns-pwhlpa-player-agent-certification",
  },
  {
    date: "September 15, 2025",
    title: "Another Article Title",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Luquay_Washington.png",
    link: "/content/smww-agency-welcomes-new-athlete-luquay-washington",
  },  {
    date: "November 02, 2025",
    title: "SMWW Agent Advisor Kenya Fari Earns FIBA Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/SMWW_Agency-Kenya_Fari_Agent_Advisor.png",
    link: "/content/smww-agent-advisor-kenya-fari-earns-fiba-certification",
  },
  {
    date: "October 20, 2025",
    title: "SMWW Hockey Agency Director Michael Collier Earns Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Michael_Collier_SMWW_Hockey_Agency_Director.png",
    link: "/content/smww-hockey-agency-director-michael-collier-earns-pwhlpa-player-agent-certification",
  },
  {
    date: "September 15, 2025",
    title: "Another Article Title",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Luquay_Washington.png",
    link: "/content/smww-agency-welcomes-new-athlete-luquay-washington",
  },  {
    date: "November 02, 2025",
    title: "SMWW Agent Advisor Kenya Fari Earns FIBA Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/SMWW_Agency-Kenya_Fari_Agent_Advisor.png",
    link: "/content/smww-agent-advisor-kenya-fari-earns-fiba-certification",
  },
  {
    date: "October 20, 2025",
    title: "SMWW Hockey Agency Director Michael Collier Earns Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Michael_Collier_SMWW_Hockey_Agency_Director.png",
    link: "/content/smww-hockey-agency-director-michael-collier-earns-pwhlpa-player-agent-certification",
  },
  {
    date: "September 15, 2025",
    title: "Another Article Title",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Luquay_Washington.png",
    link: "/content/smww-agency-welcomes-new-athlete-luquay-washington",
  },  {
    date: "November 02, 2025",
    title: "SMWW Agent Advisor Kenya Fari Earns FIBA Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/SMWW_Agency-Kenya_Fari_Agent_Advisor.png",
    link: "/content/smww-agent-advisor-kenya-fari-earns-fiba-certification",
  },
  {
    date: "October 20, 2025",
    title: "SMWW Hockey Agency Director Michael Collier Earns Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Michael_Collier_SMWW_Hockey_Agency_Director.png",
    link: "/content/smww-hockey-agency-director-michael-collier-earns-pwhlpa-player-agent-certification",
  },
  {
    date: "September 15, 2025",
    title: "Another Article Title",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Luquay_Washington.png",
    link: "/content/smww-agency-welcomes-new-athlete-luquay-washington",
  },  {
    date: "November 02, 2025",
    title: "SMWW Agent Advisor Kenya Fari Earns FIBA Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/SMWW_Agency-Kenya_Fari_Agent_Advisor.png",
    link: "/content/smww-agent-advisor-kenya-fari-earns-fiba-certification",
  },
  {
    date: "October 20, 2025",
    title: "SMWW Hockey Agency Director Michael Collier Earns Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Michael_Collier_SMWW_Hockey_Agency_Director.png",
    link: "/content/smww-hockey-agency-director-michael-collier-earns-pwhlpa-player-agent-certification",
  },
  {
    date: "September 15, 2025",
    title: "Another Article Title",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Luquay_Washington.png",
    link: "/content/smww-agency-welcomes-new-athlete-luquay-washington",
  },  {
    date: "November 02, 2025",
    title: "SMWW Agent Advisor Kenya Fari Earns FIBA Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/SMWW_Agency-Kenya_Fari_Agent_Advisor.png",
    link: "/content/smww-agent-advisor-kenya-fari-earns-fiba-certification",
  },
  {
    date: "October 20, 2025",
    title: "SMWW Hockey Agency Director Michael Collier Earns Certification",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Michael_Collier_SMWW_Hockey_Agency_Director.png",
    link: "/content/smww-hockey-agency-director-michael-collier-earns-pwhlpa-player-agent-certification",
  },
  {
    date: "September 15, 2025",
    title: "Another Article Title",
    author: "Dr. Lynn Lashbrook",
    image: "/basic/web/images/agent/Luquay_Washington.png",
    link: "/content/smww-agency-welcomes-new-athlete-luquay-washington",
  },
  
];
       // setBlogData(blogData);

        

    },[]);

    useEffect(() => {
        Promise.all([
            getagencynewslist()
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);
async function getagencynewslist() {
    
       try {
        
    const response = await fetch(
      app_url+'smwwblog/getagencynewslist',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setBlogData(responsedata.data.result);
    }
    } catch (error) {
        console.error(error);
      }finally {
             // Set loading to false after fetch completes (success or error)
          }
  
  }
    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
      const handleViewMore = () => {
    setVisibleCount((prev) => prev + 10); // show 2 more cards each click
  };
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="smww-agency-news-main">
                <Helmet><title>SMWW Sports Agency News</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div className="agency-news-container">
                        <h1 style={{"borderLeft":"none","textAlign":"center"}}>SMWW Sports Agency News</h1>
                    </div>
                    <div className="container" id="results">
                {blogData.slice(0, visibleCount).map((blog, index) => (
                    <div className="smw-sta-blog-card" key={index}>
                    <div className="meta">
                        <div className="photo">
                        <img src={blog.image} alt={blog.title} />
                        </div>
                    </div>
                    <div className="description">
                        <h2>{blog.date}</h2>
                        <h1>{blog.title}</h1>
                        <p></p>
                        {blog.author && 
                        <h2>by {blog.author}</h2>
}
                        <a target="_blank" rel="noopener noreferrer" href={blog.link}>
                        <button className="button mr-1 arrow">Read Article <strong>→</strong></button>
                        </a>
                    </div>
                    </div>
                ))}

                {visibleCount < blogData.length && (
                    <div id="loader_message" style={{ textAlign: "center" }}>
                    <button
                        id="view_more"
                        className="button mr-1 arrow"
                        type="button"
                        onClick={handleViewMore}
                    >
                        View More
                    </button>
                    </div>
                )}
                </div>
                </div>
                <div className="right">
                    
                </div>
            </div>
        )}
        </>
    );
};
export default AgencyNewsList;